<template>
<div class="IFTC">
  <iframe class="znr" ref="prints" :src="src"></iframe>
</div>
</template>

<script>
export default {
  name: "IFTC",
  data() {
    return {
      src: ''
    }
  },
  props: {
    srccs: {
      default: 1
    }
  },
  created() {
    let num = this.srccs
    let src = ''
    switch (num) {
      case '1':
        src = this._getUrl('Page_OperationCHPPrint')
        src = src.replace("{ChooseId}", this.$store.state.physicianVisits.xzConsulting)
        src = src.replace("{ExpertId}", this.$store.state.users.employees.ExpertId)
        break
      case '2':
        src = this._getUrl('Page_LabtestCHPPrint')
        src =src.replace("{ChooseId}", this.$store.state.physicianVisits.xzConsulting)
        src =src.replace("{ExpertId}", this.$store.state.users.employees.ExpertId)
        break
      case '3':
        src = this._getUrl('Page_ExamCHPPrint')
        src =src.replace("{ChooseId}", this.$store.state.physicianVisits.xzConsulting)
        src =src.replace("{ExpertId}", this.$store.state.users.employees.ExpertId)
        break
      case '4':
        src = this._getUrl(':Page_TreatmentCHPPrint')
        src = src.replace("{ChooseId}", this.$store.state.physicianVisits.xzConsulting)
        src = src.replace("{ExpertId}", this.$store.state.users.employees.ExpertId)
        break
      case '5':
        src = this._getUrl('Page_DrugCHPPrint')
        src = src = src.replace('{ChooseId}', this.$store.state.physicianVisits.xzConsulting)
        src =src = src.replace('{ExpertId}', this.$store.state.users.employees.ExpertId)
        break
    }
    this.src = src
  }
}
</script>

<style scoped lang="scss">
.znr {
  width: 100%;
  height: 65vh;
}
</style>
